import React from 'react'
import { CardContent, CardHeader, Grid, IconButton, Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import RonadIcons from '../iconComponent';
import classes from './counterCard.module.css'

interface Props {
    data: string;
    isActive: boolean;
    label: string;
    handleClick: () => void;
    icon: string;
    iconColor: string
    color: string;
    dActiveCard: () => void
}

const CounterCard = ({
    data,
    isActive,
    label,
    handleClick,
    icon,
    dActiveCard,
    color,
    iconColor
}: Props) => {

    return (
        <div
            className={
                isActive
                    ? classes.boxShadow
                    : classes.cards
            }
        >
            {
                isActive && (
                    <div
                        onClick={dActiveCard}
                        className={classes.iconHeader}
                        data-cy="cardCloseBtn"
                    >
                        <RonadIcons name="x-close" className='pointer' color='error'  size='20'/>
                    </div>
                )
            }
            <div className={classes.cardContent} onClick={handleClick}>
                <div className={classes.icon}>
                    <RonadIcons name={icon} className='pointer' size={1.7}  style={{
                        color: iconColor
                    }}/>
                </div>
                <Grid
                    className={classes.content}
                >
                    <Typography
                        variant="h6"
                        component="h6"
                        className={classes.contentData}
                        data-cy="processingCount"
                    >
                        {data}
                    </Typography>
                    <Typography
                        
                    >
                        {label}
                    </Typography>
                </Grid>
            </div>
        </div>
    )
}

export default CounterCard;
